import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";

function Page() {
  const [articleContent, setArticleContent] = useState({});
  const videoRef = useRef(null);
  const triggerRef = useRef(null);
  const [playedOnce, setPlayedOnce] = useState(false);
  let location = useLocation();

  useEffect(() => {
    let searchParams = new URLSearchParams(location.search);
    let id = searchParams.get("id");

    axios
      .post("/api/website/getArticle", { id: id * 1 })
      .then((response) => {
        const pageData = response.data.data.result;
        setArticleContent(pageData);
      })
      .catch((error) => {
        console.error("Error fetching article content:", error);
      });

    const currentTrigger = triggerRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;
        if (entry.isIntersecting && videoRef.current && !playedOnce) {
          videoRef.current.play();
          setPlayedOnce(true);
        }
      },
      {
        rootMargin: "0px",
        threshold: 0.1,
      }
    );

    if (currentTrigger) {
      observer.observe(currentTrigger);
    }

    return () => {
      if (currentTrigger) {
        observer.unobserve(currentTrigger);
      }
    };
  }, [playedOnce, location.search]);

  return (
    <>
      <Navbar />
      <main className="">
        <section className="page-content">
          <div className="text-center mb-[44px]">
            <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">
              {articleContent.title}
            </h2>
          </div>
          {articleContent.thumbnailUrl && articleContent.thumbnailUrl !== "" ? (
            <img
              src={articleContent.thumbnailUrl}
              alt={articleContent.thumbnailUrl}
              className="m-auto h-[372px] object-contain border-8 border-white shadow-xl relative mb-[44px]"
            />
          ) : null}
          <div
            className="text-start text-[#373737] font-normal text-base leading-loose mb-[40px] md-l:mx-10"
            dangerouslySetInnerHTML={{ __html: articleContent.content }}
          ></div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default Page;
